module.exports = __webpack_public_path__ + "img/company_7.13ed9d33.png";